module.exports = __webpack_public_path__ + "static/media/coffey.909d100c.png";